// @ts-nocheck
import * as types from 'appRedux/actions/loader';

const initialState = {
  loader: false,
};

function loaderReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SHOW_FULLSCREEN_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }

    case types.HIDE_FULLSCREEN_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }

    default: {
      return state;
    }
  }
}
export default loaderReducer;
